// extracted by mini-css-extract-plugin
export default {"profile":"profile_profile__nhd3c","nav":"profile_nav__74keO"};